








































































































































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import SortTableColumnButton from '@/components/UI/sort-table-column-button.vue';
import { PaginationSyncDTO, ResultPagDTO } from '@/interfaces/base-dto';
import { AcompanhamentoPacienteFiltroDTO } from '@/interfaces/dashboard';
import router from '@/routes';
import {
  getPatientsPrescriptionsMonitoringData,
  getPatientsPrescriptionsMonitoringDayData
} from '@/services/dashboard';
import { downloadPDF } from '@/services/prescription';
import { getLocalBusinessUnit, getObjSessionStorageUser, setObjSessionStorageUser } from '@/services/session-data';
import { STATUS_PRESCRIPTION_LIST } from '@/settings/consts/prescription-status';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { PATIENTS_MONITORING_PATH } from '../prescription/routes';
import { DASHBOARD_PATIENTS_MONITORING_PATH } from './routes';

@Component({
  components: {
    ListMessages,
    UiAutocompleClientsSubsidiaries,
    SortTableColumnButton
  }
})
export default class PatientsPrescrMonitoringTable extends BaseComponent {
  list = [];

  colHoverIndex = -1;

  oldUnidade = null;
  unidade = null;
  tpFiltro = null;
  situacao = null;
  validacao = null;
  tpBolsa = null;
  oldNmPaciente = null;
  nmPaciente = null;
  minMaxDias = [-2, 7];
  pagination: PaginationSyncDTO = new PaginationSyncDTO();
  pagina: ResultPagDTO<any> = new ResultPagDTO();
  loading = false;
  error = false;

  created() {
    this.buildBs();
  }

  beforeMount() {
    this.pagination.rowsPerPage = 50;
    let pag = getObjSessionStorageUser(this.SESSION_STORAGE_PAG_KEY);
    if (pag) {
      this.pagination.descending = pag.descending;
      this.pagination.sortBy = pag.sortBy;
      this.pagination.rowsPerPage = pag.rowsPerPage;
    }
    let filter = getObjSessionStorageUser(this.SESSION_STORAGE_FILTRO_KEY);
    if (!filter) {
      this.tpFiltro = 'U';
      return;
    }
    let f = filter as AcompanhamentoPacienteFiltroDTO;
    this.tpFiltro = f.tpFiltro;
    this.unidade = f.idUnidade ? { id: f.idUnidade } : null;
    this.oldUnidade = this.unidade;
    this.situacao = f.situacao;
    this.validacao = f.validacao;
    this.nmPaciente = f.nmPaciente;
    this.oldNmPaciente = this.nmPaciente;
    this.minMaxDias = [f.diasPassado * -1, f.diasFuturo];
    this.tpBolsa = f.tpBolsa;
  }

  intervalLoad = null;
  refreshing = false;
  mounted() {
    this.load(false);

    this.intervalLoad = setInterval(() => {
      if (this.refreshing || this.loading) {
        return;
      }
      this.refreshing = true;
      this.load(true);
    }, 120000);
  }

  beforeDestroy() {
    clearInterval(this.intervalLoad);
  }

  private loadSubject$: BehaviorSubject<any> = null;

  buildBs() {
    this.loadSubject$ = this.buildBehaviorSubject(
      (filters) => {
        setObjSessionStorageUser(this.SESSION_STORAGE_FILTRO_KEY, filters);
        setObjSessionStorageUser(this.SESSION_STORAGE_PAG_KEY, this.pagination);

        let autoRefresh = this.quiet;
        if (!this.quiet) {
          this.loading = true;
          this.quiet = false;
          this.list = [];
        }
        return getPatientsPrescriptionsMonitoringData(filters, autoRefresh);
      },
      () => {},
      300,
      (res) => {
        this.list = res.content;
        this.loading = false;
        this.refreshing = false;
        this.pagina = res;
        PaginationSyncDTO.update(this.pagination, res);

        this.list.forEach((i) => {
          i.dias = i.dias.map((i) => {
            return {
              ...i,
              statusView: STATUS_PRESCRIPTION_LIST.find((sp) => sp.key == i.status),
              key: Math.random()
            };
          });
        });
      },
      (error) => {
        this.loading = false;
        this.refreshing = false;
        this.showToastApiError(error);
        this.buildBs();
      }
    );
  }

  quiet = false;
  load(quiet) {
    this.quiet = quiet;
    let filters = new AcompanhamentoPacienteFiltroDTO();
    filters.idUnidade = this.unidade ? this.unidade.id : null;
    filters.tpFiltro = this.tpFiltro;
    filters.diasPassado = this.minMaxDias[0] * -1;
    filters.diasFuturo = this.minMaxDias[1];
    filters.situacao = this.situacao;
    filters.validacao = this.validacao;
    filters.nmPaciente = this.nmPaciente;
    filters.tpBolsa = this.tpBolsa;
    filters.update(this.pagination);

    this.loadSubject$.next(filters);
  }

  SESSION_STORAGE_FILTRO_KEY = 'acpp_flt';
  SESSION_STORAGE_PAG_KEY = 'acpp_pag';

  onChangeFilter() {
    this.loading = true;
    this.oldUnidade = this.unidade;
    this.oldNmPaciente = this.nmPaciente;
    this.pagination.page = 1;
    this.load(false);
  }

  btnDayMouseOver(index) {
    this.colHoverIndex = index;
  }

  diaSelec = null;
  itemSelec = null;
  showMenu = false;
  activator = null;
  menuKey = 0;

  loadDay(diaSelec, item, e) {
    this.diaSelec = diaSelec;
    this.itemSelec = item;
    this.activator = e.currentTarget;
    this.showMenu = true;

    diaSelec.loading = true;
    diaSelec.podeCancelar = false;
    diaSelec.podeCopiar = false;
    diaSelec.podeGerarPdf = false;
    diaSelec.podePrescrever = false;
    diaSelec.podeVisualizar = false;
    diaSelec.podeValidar = false;
    diaSelec.nmPrescritor = null;
    diaSelec.key = Math.random();
    getPatientsPrescriptionsMonitoringDayData(item.idPaciente, diaSelec.dia, diaSelec.idPrescricao).subscribe(
      (res) => {
        diaSelec.podeCancelar = res.podeCancelar;
        diaSelec.podeCopiar = res.podeCopiar;
        diaSelec.podeGerarPdf = res.podeGerarPdf;
        diaSelec.podePrescrever = res.podePrescrever;
        diaSelec.podeVisualizar = res.podeVisualizar;
        diaSelec.podeValidar = res.podeValidar;
        diaSelec.nmPrescritor = res.nmPrescritor;
        diaSelec.bolsaMulti = res.bolsaMulti;
        diaSelec.loading = false;
        diaSelec.key = Math.random();
        diaSelec.statusView = STATUS_PRESCRIPTION_LIST.find((sp) => sp.key == res.status);
        diaSelec.idSeqSipro = res.idSeqSipro;
        this.menuKey = this.menuKey++;
      },
      (error) => {
        diaSelec.loading = false;
        diaSelec.key = Math.random();
      }
    );
    setTimeout(() => {
      this.showMenu = true;
    }, 50);
  }

  prescribeCopy(idPrescricao) {
    let urlRedirect = `/prescricao?idCp=${idPrescricao}&editable=${true}`;
    this.redirect(urlRedirect);
  }

  prescribeNew(idUnidade, idPaciente, data) {
    let urlRedirect = `/prescricao?new=true&idUni=${idUnidade}&idPac=${idPaciente}&dt=${data}`;
    this.redirect(urlRedirect);
  }

  viewPrescription(idPrescricao) {
    let urlRedirect = `/prescricao?idVw=${idPrescricao}`;
    this.redirect(urlRedirect);
  }

  cancelPrescription(idPrescricao) {
    let urlRedirect = `/prescricao?idVw=${idPrescricao}&cnc=true`;
    this.redirect(urlRedirect);
  }

  validatePrescription(idPrescricao) {
    let urlRedirect = `/prescricao?idVw=${idPrescricao}&vld=true`;
    this.redirect(urlRedirect);
  }

  redirect(urlRedirect) {
    let callbackPath = DASHBOARD_PATIENTS_MONITORING_PATH;
    if (!this.isEmede()) {
      callbackPath = PATIENTS_MONITORING_PATH;
    }

    urlRedirect = encodeURIComponent(`${urlRedirect}&callback=${callbackPath}`);
    router.push(`?redirect=${urlRedirect}&emp=${getLocalBusinessUnit().id}`);
  }

  public exportPDF(idPrescricao: any): void {
    this.loader.start('Gerando relatório...');
    downloadPDF(idPrescricao).subscribe(
      (url) => {
        if (!url) {
          this.toast.show('Ocorreu um erro ao carregar o relatório', 'error');
        }

        window.open(url, '_blank');
        this.loader.stop();
      },
      () => {
        this.toast.show('Ocorreu um erro ao carregar o relatório', 'error');
        this.loader.stop();
      }
    );
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  private onChangePagination() {
    this.load(false);
  }

  getLabelRange() {
    let de = new Date().setDate(new Date().getDate() + this.minMaxDias[0]);
    let ate = new Date().setDate(new Date().getDate() + this.minMaxDias[1]);
    return (
      `De ${this.dateFormatHelper(de, 'DD/MMM').toLowerCase()} ` +
      `até ${this.dateFormatHelper(ate, 'DD/MMM').toLowerCase()}`
    );
  }
}
